import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"
import { orders } from "../../common/data/ecommerce"
import { apiError } from "../../store/actions"
import { get } from "lodash"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import FieldValidation from "../../components/Common/FieldValidation"
import { AvForm, AvField } from "availity-reactstrap-validation"
import {
  getAllRoles,
  createRole,
  deleteRole,
  editRole,
} from "../../store/roles/actions"
//redux
import { useSelector, useDispatch } from "react-redux"
import { capitalizeFirstLetter } from "../../helpers/helpers"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import PermissionDetailsModal from "./PermissionDetailsModal"
import { getAllPermissions } from "store/permissions/actions"
import {sitename} from "../../constants/constants";

const Roles = props => {
  const dispatch = useDispatch()

  const Roles = useSelector(state => state.roles.Index ?? [])
  const formErrors = useSelector(state => state?.CommonState)

  const selectRow = {
    mode: "checkbox",
  }

  const [modal, setModal] = useState(false)
  const [detailsModal, setdetailsModal] = useState(false)
  const [roleList, setRoleList] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: Roles.length,
    custom: true,
  }
  const { SearchBar } = Search

  // const toggleModal = () => {
  //   setdetailsModal(!detailsModal)
  // }
  const toggleViewModal = () => setdetailsModal(!detailsModal)
  const handleViewDetailsClick = (role, roleId) => {
    setRoleList({
      id: role.id,
      name: capitalizeFirstLetter(role.name.replace(/-/g, " ")),
      permissions: role.permissions,
      roleId: roleId,
    })
    setdetailsModal(!detailsModal)
  }
  const RolesColumns = toggleModal => [
    {
      dataField: "id",
      text: "Role ID",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div className="text-body fw-bold">{row.id}</div>
      ),
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        let { name } = row
        name = name.replace("-", " ")
        name = capitalizeFirstLetter(name)
        return <div className="text-body fw-bold capitalize">{name}</div>
      },
    },
    {
      dataField: "view",
      isDummyField: true,
      text: "Permissions",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <Button
          type="button"
          color="primary"
          className="btn-sm btn-rounded"
          onClick={() => {
            handleViewDetailsClick(row, row.id)
          }}
        >
          View Details
        </Button>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, role) => {
        if (role["editable"] == 1) {
          return (
            <>
              <div className="d-flex gap-3">
                <Link
                  to="#"
                  className="text-success"
                  onClick={() => handleEditRole(role)}
                >
                  <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </Link>
                <Link
                  to="#"
                  className="text-danger"
                  onClick={() => handleDeleteRole(role)}
                >
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                  />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </div>
            </>
          )
        }
      },
    },
  ]
  useEffect(() => {
    dispatch(getAllRoles())
    dispatch(getAllPermissions())
  }, [])
  useEffect(() => {
    dispatch(apiError(""))
  }, [])
  const toggle = () => {
    setModal(!modal)
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const handleDeleteRole = role => {
    if (role.id !== undefined) {
      dispatch(deleteRole(role.id))
      onPaginationPageChange(1)
    }
  }
  const handleEditRole = role => {
    setRoleList({
      id: role.id,
      name: capitalizeFirstLetter(role.name.replace("-", " ")),
    })

    setIsEdit(true)
    dispatch(apiError(""))
    toggle()
  }

  const handleValidRoleSubmit = (e, values) => {
    if (isEdit) {
      const role = {
        name: values["Name"].split(" ").join("-").toLowerCase(),
        id: roleList.id,
      }
      dispatch(editRole(role, toggle))
      onPaginationPageChange(1)
    } else {
      const role = {
        name: values["Name"].split(" ").join("-").toLowerCase(),
      }
      dispatch(createRole(role, toggle))
    }
  }

  const handleCreateNewRole = () => {
    setRoleList("")
    dispatch(apiError(""))

    setIsEdit(false)
    toggle()
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  return (
    <React.Fragment>
      <PermissionDetailsModal
        roleList={roleList}
        isOpen={detailsModal}
        toggle={toggleViewModal}
        setRoleList={setRoleList}
        setdetailsModal={setdetailsModal}
        detailsModal={detailsModal}
      />
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Roles" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={RolesColumns(toggle)}
                    data={Roles}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={Roles}
                        columns={RolesColumns(toggle)}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                                <div className="text-sm-end">
                                  <Button
                                    type="button"
                                    color="success"
                                    className="btn-rounded  mb-2 me-2"
                                    onClick={handleCreateNewRole}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Create New Role
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    ref={node}
                                    rowClasses={"mytable-hover-row"}
                                  />
                                </div>
                                <Modal isOpen={modal} toggle={toggle} centered>
                                  <ModalHeader toggle={toggle} tag="h4">
                                    {!!isEdit ? "Edit Role" : "Create New Role"}
                                  </ModalHeader>
                                  <ModalBody>
                                    <AvForm
                                      onValidSubmit={handleValidRoleSubmit}
                                    >
                                      <Row form>
                                        <Col className="col-12">
                                          <div className="mb-3">
                                            <AvField
                                              name="Name"
                                              label="Name"
                                              type="text"
                                              errorMessage="This is a required field"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              value={roleList.name || ""}
                                              className={
                                                formErrors && formErrors?.name
                                                  ? "av-invalid is-invalid"
                                                  : "form-control"
                                              }
                                            />
                                          </div>
                                          {formErrors?.name ? (
                                            <FieldValidation
                                              errorMessage={formErrors?.name}
                                            />
                                          ) : null}
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col>
                                          <div className="text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-success save-user"
                                            >
                                              Save
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </AvForm>
                                  </ModalBody>
                                </Modal>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Roles)
